import request from '@/api/request.js';

// 教务服务方列表
export const getProxyList = (params) => {
    return request({
        url: '/base/adm/company/getProxyList',
        method: 'get',
        params
    })
}

// 招生服务方列表
export const getSubProxyList = (params) => {
    return request({
        url: '/base/adm/company/getSubProxyList',
        method: 'get',
        params
    })
}

// 公司详情
export const getCompanyInfo = (params) => {
    return request({
        url: '/base/adm/companyInfo/getCompanyInfo',
        method: 'get',
        params
    })
}

// 合作申请列表
export const getCooperationApplyListPage = (params) => {
    return request({
        url: '/base/adm/cooperationApply/getListPage',
        method: 'get',
        params
    })
}

// 合作单位申请详情
export const getCooperationApply = (params) => {
    return request({
        url: '/base/adm/cooperationApply/getCooperationApply',
        method: 'get',
        params
    })
}

// 更新合作申请
export const updateCooperationApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/updateCooperationApply',
        method: 'post',
        data
    })
}

// 获取合作项目介绍
export const getProjectContent = () => {
    return request({
        url: '/radioweb/adm/cooperationApply/getProductIntroduction',
        method: 'get'
    })
}

// 设置合作项目介绍
export const setProjectContent = (params) => {
    return request({
        url: '/radioweb/adm/cooperationApply/updateProductIntroduction',
        method: 'get',
        params
    })
}

// 教务服务方审核
export const proxyAuditApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/proxyAuditApply',
        method: 'post',
        data
    })
}

// 招生服务方审核
export const auditCooperationApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/auditCooperationApply',
        method: 'post',
        data
    })
}

// 修改合作状态
export const updateCompany = (data) => {
    return request({
        url: '/base/adm/company/updateCompany',
        method: 'post',
        data
    })
}

// 新增单位申请表
export const addCooperationApply = (data) => {
    return request({
        url: '/base/app/cooperationApply/addCooperationApply',
        method: 'post',
        data
    })
}

// 修改单位申请表
export const updateCompanyInfo = (data) => {
    return request({
        url: '/base/adm/companyInfo/updateCompanyInfo',
        method: 'post',
        data
    })
}

// 公司合同列表
export const getCompanyContractListPage = (params) => {
    return request({
        url: '/base/adm/companyContract/getListPage',
        method: 'get',
        params
    })
}

// 添加公司合同
export const addCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/addCompanyContract',
        method: 'post',
        data
    })
}

// 获取公司合同详情
export const getCompanyContract = (params) => {
    return request({
        url: '/base/adm/companyContract/getCompanyContract',
        method: 'get',
        params
    })
}

// 删除公司合同
export const delCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/delCompanyContract',
        method: 'post',
        data
    })
}

// 编辑公司合同
export const updateCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/updateCompanyContract',
        method: 'post',
        data
    })
}

// 管理员列表
export const getCompanyAdminUserPageList = (data) => {
    return request({
        url: '/base/adm/companyUser/getCompanyAdminUserPageList',
        method: 'post',
        data
    })
}

// 删除管理员
export const delUserAdminRoleToCompany = (data) => {
    return request({
        url: '/base/adm/companyUser/delUserAdminRoleToCompany',
        method: 'post',
        data
    })
}

// 添加管理员
export const addAdminToCompany = (data) => {
    return request({
        url: '/base/adm/companyUser/addAdminToCompany',
        method: 'post',
        data
    })
}

// 角色列表
export const proxyRole = (params) => {
    return request({
        url: '/base/proxyRole',
        method: 'get',
        params
    })
}

// 角色列表
export const subProxyRole = (params) => {
    return request({
        url: '/base/subProxyRole',
        method: 'get',
        params
    })
}

// 添加教务服务方角色
export const addProxyRole = (data) => {
    return request({
        url: '/base/role/addProxyRole',
        method: 'post',
        data
    })
}

// 添加招生服务方角色
export const addSubProxyRole = (data) => {
    return request({
        url: '/base/role/addSubProxyRole',
        method: 'post',
        data
    })
}

// 编辑角色
export const updateRole = (data) => {
    return request({
        url: '/base/role/update',
        method: 'post',
        data
    })
}

// 获取教务服务方菜单列表
export const getAuthorityproxyMenu = (params) => {
    return request({
        url: '/base/authority/proxyMenu',
        method: 'get',
        params
    })
}

// 获取招生服务方菜单列表
export const getAuthoritysubProxyMenu = (params) => {
    return request({
        url: '/base/authority/subProxyMenu',
        method: 'get',
        params
    })
}

// 获取角色授权列表
export const getRoleAuthInfoList = (data) => {
    return request({
        url: '/base/adm/companyRole/getRoleAuthInfoList',
        method: 'post',
        data
    })
}

// 角色授权全部显示与隐藏
export const updateAllStatus = (data) => {
    return request({
        url: '/base/adm/companyRole/updateAllStatus',
        method: 'post',
        data
    })
}

// 角色授权
export const updateStatus = (data) => {
    return request({
        url: '/base/adm/companyRole/updateStatus',
        method: 'post',
        data
    })
}

// 获取功能列表
export const getAuthorityRole = (params) => {
    return request({
        url: '/base/authority/role',
        method: 'get',
        params
    })
}

// 分配权限
export const grantAuthorityRole = (data) => {
    return request({
        url: '/base/authority/role/grant',
        method: 'post',
        data
    })
}

// 分配教务服务方菜单
export const assignMenuToProxyCompany = (data) => {
    return request({
        url: '/base/company/assignMenuToProxyCompany',
        method: 'post',
        data
    })
}

// 分配招生服务方菜单
export const assignMenuToSubProxyCompany = (data) => {
    return request({
        url: '/base/company/assignMenuToSubProxyCompany',
        method: 'post',
        data
    })
}

// 菜单列表
export const getOmAll = (params) => {
    return request({
        url: 'base/menu/getOmAll',
        method: 'get',
        params
    })
}

// 驳回列表
export const getCompanyRejectReasonListPage = (params) => {
    return request({
        url: '/base/adm/companyRejectReason/getListPage',
        method: 'get',
        params
    })
}

// 添加驳回原因
export const addCompanyRejectReason = (data) => {
    return request({
        url: '/base/adm/companyRejectReason/addCompanyRejectReason',
        method: 'post',
        data
    })
}

// 审核合同
export const auditCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/auditCompanyContract',
        method: 'post',
        data
    })
}

// 驳回原因列表
export const getRejectedList = (params) => {
    return request({
        url: '/base/adm/contractRejectReason/getListPage',
        method: 'get',
        params
    })
}

// 平台总数据(超管)
export const getPlatformData = (data) => {
    return request({
      url: '/analyse/adm/orderCalData/getSuperPlatData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台总数据(超管)(教务服务方数据列表)
export const getPlatformDataList = (data) => {
    return request({
      url: '/analyse/adm/orderCalData/getSuperPlatAgentData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台总数据(教务服务方)
export const getAgentPlatformData = (data) => {
  return request({
    url: '/analyse/adm/orderCalData/getAgentPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台总数据(招生服务方)
export const getDistributorPlatfromData = (data) => {
  return request({
    url: '/analyse/adm/orderCalData/getDistributorPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(超管)
export const getRefundPlatformData = (data) => {
    return request({
      url: '/order/adm/refundCalData/getSuperPlatData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台退款数据(超管)(教务服务方数据列表)
export const getRefundPlatformDataList = (data) => {
    return request({
      url: '/order/adm/refundCalData/getSuperPlatAgentData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台退款数据(教务服务方)
export const getAgentRefundPlatformData = (data) => {
  return request({
    url: '/order/adm/refundCalData/getAgentPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(招生服务方)
export const getDistributorRefundPlatfromData = (data) => {
  return request({
    url: '/order/adm/refundCalData/getDistributorPlatRefundData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(招生服务方)
export const getContracts = (data) => {
  return request({
    url: '/order/adm/order/getContracts',
    method: 'post',
    data
  })
}

// 平台退款数据(招生服务方)
export const bindContractId = (data) => {
  return request({
    url: '/base/adm/company/bindContractId',
    method: 'post',
    data
  })
}

// 获取讯飞分账比例配置
export const getContractsInfo = (data) => {
  return request({
    url: '/order/adm/order/getContractsInfo',
    method: 'post',
    data
  })
}

// 设置分账比例
export const setAccountRate = (data) => {
  return request({
    url: '/base/adm/company/setAccountRate',
    method: 'post',
    data
  })
}

// 设置分账比例(1113)
// export const updateCheckAcceptStandard = (data) => {
//   return request({
//     url: '/base/adm/company/updateCheckAcceptStandard',
//     method: 'post',
//     data
//   })
// }

// 获取签约信息
export const getCompanySignInfo = (params) => {
  return request({
    url: '/base/adm/company/getCompanyById',
    method: 'get',
    params
  })
}
// 设置签约信息
export const updataeSignInfo = (data) => {
  return request({
    url: '/base/adm/company/updateSeal',
    method: 'post',
    data
  })
}

// 获取租户保证金
export const getCompanySurety = (data) => {
  return request({
    url: '/order/adm/bond/one',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取保证金调整类型
export const getBondWay = (params) => {
  return request({
    url: '/order/adm/order/getBondWay',
    method: 'get',
    params
  })
}

// 保证金调整
export const adjustBond = (data) => {
  return request({
    url: '/order/adm/bond/adjust',
    method: 'post',
    type: 'json',
    data
  })
}

// 保证金调整记录
export const adjustBondLogList = (data) => {
  return request({
    url: '/order/adm/bond/logList',
    method: 'post',
    type: 'json',
    data
  })
}

// 分账比例配置列表
export const getContractList = (params) => {
  return request({
    url: '/base/adm/companySplitConfig/findListPage',
    method: 'get',
    params
  })
}

// 删除本地合约配置
export const deleteContractConfig = (data) => {
  return request({
    url: '/base/adm/companySplitConfig/delConfig',
    method: 'post',
    data
  })
}

// 获取项目列表
export const listProject = () => {
  return request({
    url: 'admin/product/adm/project/listProject',
    method: 'get'
  })
}

// 获取分账合约列表
export const getSplitContractList = (data) => {
  return request({
    url: '/order/adm/order/getSplitContractList',
    method: 'post',
    data
  })
}

// 创建分账合约
export const addSplitContract = (data) => {
  return request({
    url: '/base/adm/companySplitConfig/addSplitContract',
    method: 'post',
    data
  })
}

// 获取讯飞分账比例配置
export const getSplitContractInfo = (data) => {
  return request({
    url: '/order/adm/order/getSplitContractInfo',
    method: 'post',
    data
  })
}

// 设置分账比例
export const updateCheckAcceptStandard = (data) => {
  return request({
    url: '/base/adm/companySplitConfig/updateCheckAcceptStandard',
    method: 'post',
    data
  })
}
